// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2bTla","title":"card_title__2wxKQ","inActive":"card_inActive__3qG5Z"};